import React, {

  useCallback,

  useEffect,

  useMemo,

  useState,

} from "react";



import {

  ArrowLeft,

  Plus,

  Search,

  X,

} from "lucide-react";



import I from "../component/Icon";

import apiService from "../services/apiService";



const PAGE_SIZE = 10;



const GET_PAGINATED_USER_ROLES_API =

  "UserRole/getPaginatedUserRoles";



const ADD_USER_ROLE_API =

  "UserRole/addUserRole";



const UPDATE_USER_ROLE_API =

  "UserRole/updateUserRole";



const DELETE_USER_ROLE_API =

  "UserRole/DeleteUserRole";





export default function UserRoleListPage() {



  const [roles, setRoles] =

    useState([]);



  const [search, setSearch] =

    useState("");



  const [pageNumber, setPageNumber] =

    useState(1);



  const [modalOpen, setModalOpen] =

    useState(false);



  const [editing, setEditing] =

    useState(null);



  const [form, setForm] =

    useState({

      name: "",

      description: "",

    });



  const [selectedView, setSelectedView] =

    useState(null);



  const [deleteTarget, setDeleteTarget] =

    useState(null);



  const [totalRecords, setTotalRecords] =

    useState(0);





  /* =====================================================

     NOTIFICATION

  ===================================================== */



  const [notification, setNotification] =

    useState(null);



  const showNotification = (

    type,

    message

  ) => {



    setNotification({

      type,

      message,

    });

  };





  useEffect(() => {



    if (!notification) {

      return;

    }



    const timer =

      setTimeout(() => {



        setNotification(null);



      }, 3000);



    return () =>

      clearTimeout(timer);



  }, [notification]);





  /* =====================================================

     GET PAGINATED USER ROLES - BACKEND API

  ===================================================== */



  const loadRoles = useCallback(



    async (

      currentPage = 1,

      searchValue = "",

      signal = undefined

    ) => {



      try {



        const requestBody = {



          Page: currentPage,



          PageSize:

            PAGE_SIZE,



          SearchTerm:

            searchValue.trim(),



          SortDirection:

            "DESC",



          SortField:

            "Id",

        };





        console.log(

          "Get Paginated User Roles Request:",

          requestBody

        );





        if (signal?.aborted) {

          return;

        }





        const response =

          await apiService.post(



            GET_PAGINATED_USER_ROLES_API,



            requestBody

          );





        if (signal?.aborted) {

          return;

        }





        const data =

          response.data;





        console.log(

          "Get Paginated User Roles Response:",

          data

        );





        const output =



          data?.output ??



          data?.Output ??



          data?.data ??



          data?.Data ??



          data;





        const result =



          Array.isArray(output)



            ? output



            : Array.isArray(

                output?.result

              )



            ? output.result



            : Array.isArray(

                output?.Result

              )



            ? output.Result



            : Array.isArray(

                output?.data

              )



            ? output.data



            : Array.isArray(

                output?.Data

              )



            ? output.Data



            : [];





        const normalizedRoles =



          result.map((role) => {



            const activeValue =



              role?.isActive ??



              role?.IsActive ??



              role?.active ??



              role?.Active ??



              false;





            return {



              ...role,





              id:



                role?.id ??



                role?.Id ??



                role?.userRoleId ??



                role?.UserRoleId,





              name:



                role?.roleName ??



                role?.RoleName ??



                role?.name ??



                role?.Name ??



                "",





              description:



                role?.description ??



                role?.Description ??



                "",





              active:



                activeValue === true ||



                Number(activeValue) === 1 ||



                String(

                  activeValue

                ).toLowerCase() ===

                  "true",

            };

          });





        const visibleRoles =



          normalizedRoles.filter(



            (role) =>

              role.active



          );





        const rolesWithDisplayId =



          visibleRoles.map(



            (role, index) => ({



              ...role,



              displayId:



                (currentPage - 1) *



                  PAGE_SIZE +



                index +



                1,



            })



          );





        setRoles(

          rolesWithDisplayId

        );





        setTotalRecords(

          Number(
            output?.rowCount ?? output?.RowCount ??
            output?.totalRecords ?? output?.TotalRecords ??
            data?.rowCount ?? data?.RowCount ??
            data?.totalRecords ?? data?.TotalRecords ??
            rolesWithDisplayId.length
          ) || 0
        );





      } catch (error) {





        if (

          error?.name ===

          "AbortError"

        ) {



          return;

        }





        console.error(



          "Get Paginated User Roles API Error:",



          error

        );





        setRoles([]);



        setTotalRecords(0);



      }



    },



    []



  );





  /* =====================================================

     PAGINATION

  ===================================================== */



  const totalPages =

    Math.max(



      1,



      Math.ceil(

        totalRecords /

        PAGE_SIZE

      )



    );





  const pageNumbers =

    Array.from(



      {

        length:

          totalPages,

      },



      (_, index) =>

        index + 1



    );





  const paginatedRows =

    useMemo(



      () => roles,



      [roles]



    );





  useEffect(() => {



    setPageNumber(1);



  }, [search]);





  useEffect(() => {



    if (

      pageNumber >

      totalPages

    ) {



      setPageNumber(

        totalPages

      );

    }



  }, [

    pageNumber,

    totalPages,

  ]);





  /* =====================================================

     LOAD TABLE DATA FROM BACKEND

  ===================================================== */



  useEffect(() => {



    const controller =

      new AbortController();





    const timer =

      setTimeout(() => {



        loadRoles(



          pageNumber,



          search,



          controller.signal



        );



      }, 300);





    return () => {



      clearTimeout(timer);



      controller.abort();



    };



  }, [



    pageNumber,



    search,



    loadRoles,



  ]);





  /* =====================================================

     OPEN ADD

  ===================================================== */



  const openAdd = () => {



    setEditing(null);





    setForm({



      name: "",



      description: "",



    });





    setNotification(null);



    setModalOpen(true);



  };





  /* =====================================================

     OPEN EDIT

  ===================================================== */



  const openEdit = (

    role

  ) => {



    setEditing(role);





    setForm({



      name:

        role.name,



      description:

        role.description,



    });





    setNotification(null);



    setModalOpen(true);



  };





  /* =====================================================

     ADD / UPDATE USER ROLE

  ===================================================== */



  const save = async (

    event

  ) => {



    event.preventDefault();





    /* ================= VALIDATION ================= */



    if (

      !form.name.trim()

    ) {



      showNotification(



        "error",



        "Role Name is required."



      );



      return;

    }





    /* =====================================================

       EDIT USER ROLE - BACKEND API

    ===================================================== */



    if (editing) {



      try {



        const roleId =

          Number(



            editing?.id ??



            editing?.Id



          );





        if (

          !roleId ||

          Number.isNaN(

            roleId

          )

        ) {



          showNotification(



            "error",



            "Invalid User Role Id."



          );



          return;

        }





        const apiPayload = {



          Id:

            roleId,





          RoleName:

            form.name.trim(),





          Description:

            form.description.trim(),





          IsActive:



            editing?.active ??



            editing?.isActive ??



            editing?.IsActive ??



            true,



        };





        console.log(



          "Update User Role Request:",



          apiPayload



        );





        const response =



          await apiService.put(



            UPDATE_USER_ROLE_API,



            apiPayload



          );





        console.log(



          "Update User Role Status:",



          response.status



        );





        console.log(



          "Update User Role Response:",



          response.data



        );





        setModalOpen(false);



        setEditing(null);





        await loadRoles(



          pageNumber,



          search



        );





        showNotification(



          "success",



          "User Role updated successfully."



        );





      } catch (error) {





        console.error(



          "Update User Role API Error:",



          error



        );





        showNotification(



          "error",



          error

            ?.response

            ?.data

            ?.failureReason ||



          error

            ?.response

            ?.data

            ?.FailureReason ||



          error

            ?.response

            ?.data

            ?.message ||



          error

            ?.response

            ?.data

            ?.Message ||



          error?.message ||



          "Failed to update user role"



        );



      }





      return;



    }





    /* =====================================================

       ADD USER ROLE - BACKEND API

    ===================================================== */



    try {



      const apiPayload = {



        RoleName:

          form.name.trim(),





        Description:

          form.description.trim(),





        IsActive:

          true,



      };





      console.log(



        "Add User Role Request:",



        apiPayload



      );





      const response =



        await apiService.post(



          ADD_USER_ROLE_API,



          apiPayload



        );





      console.log(



        "Add User Role Status:",



        response.status



      );





      console.log(



        "Add User Role Response:",



        response.data



      );





      /* =====================================================

         ADD SUCCESS - RELOAD TABLE FROM BACKEND

      ===================================================== */



      setSearch("");



      setPageNumber(1);



      setModalOpen(false);



      setEditing(null);





      await loadRoles(



        1,



        ""



      );





      showNotification(



        "success",



        "User Role added successfully."



      );





    } catch (error) {





      console.error(



        "Add User Role API Error:",



        error



      );





      showNotification(



        "error",



        error

          ?.response

          ?.data

          ?.failureReason ||



        error

          ?.response

          ?.data

          ?.FailureReason ||



        error

          ?.response

          ?.data

          ?.message ||



        error

          ?.response

          ?.data

          ?.Message ||



        error?.message ||



        "Failed to add user role"



      );



    }



  };





  /* =====================================================

     DELETE USER ROLE

  ===================================================== */



  const confirmDelete =

    async () => {





      if (!deleteTarget) {

        return;

      }





      const roleId =

        Number(



          deleteTarget?.id ??



          deleteTarget?.Id



        );





      if (

        !roleId ||

        Number.isNaN(

          roleId

        )

      ) {



        showNotification(



          "error",



          "Invalid User Role Id."



        );



        return;

      }





      try {





        console.log(



          "Delete User Role Id:",



          roleId



        );





        const response =



          await apiService.delete(



            `${DELETE_USER_ROLE_API}/${roleId}`



          );





        console.log(



          "Delete User Role Status:",



          response.status



        );





        console.log(



          "Delete User Role Response:",



          response.data



        );





        /* =====================================================

           DELETE SUCCESS - REMOVE ROW FROM TABLE IMMEDIATELY

        ===================================================== */



        setRoles(

          (prev) =>



            prev



              .filter(



                (role) =>



                  Number(

                    role.id

                  ) !==

                  roleId



              )



              .map(



                (

                  role,

                  index

                ) => ({



                  ...role,





                  displayId:



                    (pageNumber - 1) *



                      PAGE_SIZE +



                    index +



                    1,



                })



              )



        );





        setTotalRecords(

          (prev) =>



            Math.max(



              0,



              Number(prev) - 1



            )



        );





        const moveToPreviousPage =



          pageNumber > 1 &&



          roles.length === 1;





        setDeleteTarget(null);





        if (

          moveToPreviousPage

        ) {



          setPageNumber(



            (prev) =>



              Math.max(



                1,



                prev - 1



              )



          );

        }





        showNotification(



          "success",



          "User Role deleted successfully."



        );





      } catch (error) {





        console.error(



          "Delete User Role API Error:",



          error



        );





        showNotification(



          "error",



          error

            ?.response

            ?.data

            ?.failureReason ||



          error

            ?.response

            ?.data

            ?.FailureReason ||



          error

            ?.response

            ?.data

            ?.message ||



          error

            ?.response

            ?.data

            ?.Message ||



          error?.message ||



          "Failed to delete user role"



        );



      }



    };





  /* =====================================================

     VIEW PAGE

  ===================================================== */



  if (selectedView) {



    return (



      <div className="um-page" style={{ minWidth: 0, maxWidth: "100%", overflowX: "hidden" }}>





        <div className="um-card">





          <div className="um-card-head">





            <h2>

              View User Role

            </h2>





            <button



              className="

                um-primary-btn

              "



              onClick={() =>

                setSelectedView(

                  null

                )

              }



            >



              <ArrowLeft

                size={17}

              />



              Back



            </button>





          </div>





          <div className="um-modal-body">





            <div className="um-grid-2">





              <label className="um-field">



                <span>

                  Id

                </span>



                <input



                  value={

                    selectedView

                      .displayId

                  }



                  readOnly



                />



              </label>





              <label className="um-field">



                <span>

                  Role Name

                </span>



                <input



                  value={

                    selectedView

                      .name

                  }



                  readOnly



                />



              </label>





              <label className="um-field">



                <span>

                  Description

                </span>



                <input



                  value={

                    selectedView

                      .description

                  }



                  readOnly



                />



              </label>





              <label className="um-field">



                <span>

                  Active

                </span>



                <input



                  value={



                    selectedView

                      .active



                      ? "Yes"



                      : "No"



                  }



                  readOnly



                />



              </label>





            </div>





          </div>





        </div>





      </div>



    );



  }





  /* =====================================================

     MAIN PAGE

  ===================================================== */



  return (



    <div className="um-page" style={{ minWidth: 0, maxWidth: "100%", overflowX: "hidden" }}>





      {/* =====================================================

          NOTIFICATION

      ===================================================== */}



      {notification && (



        <div



          style={{



            position:

              "fixed",





            top:

              "20px",



            right:

              "20px",





            zIndex:

              99999,





            minWidth:

              "280px",



            maxWidth:

              "420px",





            padding:

              "12px 16px",





            borderRadius:

              "8px",





            backgroundColor:



              notification.type ===

              "success"



                ? "#d1e7dd"



                : "#f8d7da",





            color:



              notification.type ===

              "success"



                ? "#0f5132"



                : "#842029",





            border:



              notification.type ===

              "success"



                ? "1px solid #badbcc"



                : "1px solid #f5c2c7",





            fontSize:

              "14px",





            fontWeight:

              600,





            boxShadow:



              "0 4px 12px rgba(0,0,0,0.15)",



          }}



        >





          {



            notification.type ===

            "success"



              ? "✓ "



              : "✕ "



          }





          {

            notification.message

          }





        </div>



      )}





      
      <style>{`
        .um-page .pagination-footer { width:100% !important; max-width:100% !important; min-width:0 !important; flex-wrap:wrap !important; overflow:hidden !important; }
        .um-page .pagination-bar { display:flex !important; align-items:center !important; flex:1 1 320px !important; min-width:0 !important; max-width:100% !important; gap:5px !important; overflow:hidden !important; justify-content:flex-end !important; }
        .um-page .pagination-bar > button { flex:0 0 auto !important; }
        .um-page .pagination-numbers { display:flex !important; align-items:center !important; min-width:0 !important; flex:0 1 auto !important; max-width:100% !important; overflow-x:auto !important; overflow-y:hidden !important; white-space:nowrap !important; scrollbar-width:thin; -webkit-overflow-scrolling:touch; overscroll-behavior-x:contain; }
        .um-page .pagination-numbers > button { flex:0 0 auto !important; }
        @media(max-width:768px) {
          .um-page .pagination-footer { flex-direction:column !important; align-items:stretch !important; gap:9px !important; }
          .um-page .pagination-bar { flex:0 0 auto !important; width:100% !important; justify-content:space-between !important; }
          .um-page .pagination-numbers { flex:1 1 0 !important; max-width:none !important; }
          .um-page .pagination-bar > button { min-width:51px !important; padding:0 7px !important; font-size:10px !important; }
          .um-page .pagination-numbers > button { min-width:30px !important; padding:0 7px !important; }
        }
      `}</style>
<div className="um-card">





        {/* =====================================================

            HEADER

        ===================================================== */}



        <div className="um-card-head">





          <h2>

            User Role List

          </h2>





          <div className="um-head-actions">





            <button



              className="

                um-primary-btn

              "



              onClick={

                openAdd

              }



            >



              <Plus

                size={17}

              />



              Add New User Role



            </button>





            <label className="um-search">





              <Search

                size={17}

              />





              <input



                value={

                  search

                }



                onChange={(e) =>



                  setSearch(

                    e.target.value

                  )



                }



                placeholder="

                  Search...

                "



              />





            </label>





          </div>





        </div>





        {/* =====================================================

            TABLE

        ===================================================== */}



        <div className="um-table-wrap">





          <table className="um-table">





            <thead>



              <tr>



                <th>

                  Id

                </th>



                <th>

                  Role Name

                </th>



                <th>

                  Description

                </th>



                <th>

                  Active

                </th>



                <th>

                  Actions

                </th>



              </tr>



            </thead>





            <tbody>





              {



                paginatedRows.map(



                  (role) => (





                    <tr

                      key={

                        role.id

                      }

                    >





                      <td>



                        {

                          role.displayId

                        }



                      </td>





                      <td>



                        {

                          role.name

                        }



                      </td>





                      <td>



                        {

                          role.description

                        }



                      </td>





                      <td>



                        {

                          role.active

                            ? "Yes"

                            : "No"

                        }



                      </td>





                      <td>





                        <div className="ra">





                          {/* VIEW */}



                          <button



                            type="button"



                            className="

                              btn

                              btn-p

                              btn-sm

                            "



                            title="View"



                            onClick={() =>



                              setSelectedView(

                                role

                              )



                            }



                          >





                            <I



                              n="eye"



                              s={11}



                              c="#fff"



                            />





                          </button>





                          {/* EDIT */}



                          <button



                            type="button"



                            className="

                              btn

                              btn-g

                              btn-sm

                            "



                            title="Edit"



                            onClick={() =>



                              openEdit(

                                role

                              )



                            }



                          >





                            <I



                              n="edit"



                              s={11}



                            />





                          </button>





                          {/* DELETE */}



                          <button



                            type="button"



                            className="

                              btn

                              btn-d

                              btn-sm

                            "



                            title="Delete"



                            onClick={() =>



                              setDeleteTarget(

                                role

                              )



                            }



                          >





                            <I



                              n="trash"



                              s={11}



                            />





                          </button>





                        </div>





                      </td>





                    </tr>





                  )



                )



              }





            </tbody>





          </table>





        </div>





        {/* =====================================================

            PAGINATION

        ===================================================== */}



        {

          totalRecords > 0 &&

          (



            <div className="pagination-footer"



              style={{



                width:

                  "100%",





                display:

                  "flex",





                alignItems:

                  "center",





                justifyContent:

                  "space-between",





                gap:

                  "16px",





                marginTop:

                  "16px",





                padding:

                  "12px 4px 4px",





                borderTop:

                  "1px solid #eef2f7",



              }}



            >





              {/* LEFT SIDE */}



              <div



                style={{



                  display:

                    "flex",



                  alignItems:

                    "center",



                  whiteSpace:

                    "nowrap",



                  fontSize:

                    "11px",



                  lineHeight:

                    "16px",



                  color:

                    "var(--t3)",



                }}



              >





                Showing{" "}





                <span



                  style={{



                    margin:

                      "0 4px",



                    fontWeight:

                      600,



                    color:

                      "var(--t2)",



                  }}



                >





                  {

                    (pageNumber - 1) *

                      PAGE_SIZE +

                    1

                  }





                </span>





                –





                <span



                  style={{



                    margin:

                      "0 4px",



                    fontWeight:

                      600,



                    color:

                      "var(--t2)",



                  }}



                >





                  {



                    Math.min(



                      pageNumber *

                        PAGE_SIZE,



                      totalRecords



                    )



                  }





                </span>





                {" "}of{" "}





                <span



                  style={{



                    marginLeft:

                      "4px",



                    fontWeight:

                      600,



                    color:

                      "var(--t2)",



                  }}



                >





                  {

                    totalRecords

                  }





                </span>





              </div>





              {/* RIGHT SIDE */}



              <div
                className="pagination-bar"



                style={{



                  display:

                    "flex",



                  alignItems:

                    "center",



                  gap:

                    "5px",



                }}



              >





                {/* BACK */}



                <button



                  type="button"



                  disabled={

                    pageNumber ===

                    1

                  }



                  onClick={() =>



                    setPageNumber(



                      (previous) =>



                        Math.max(



                          1,



                          previous - 1



                        )



                    )



                  }



                  style={{



                    height:

                      "32px",



                    minWidth:

                      "66px",



                    padding:

                      "0 10px",



                    display:

                      "inline-flex",



                    alignItems:

                      "center",



                    justifyContent:

                      "center",



                    gap:

                      "3px",



                    border:

                      "1px solid #e2e8f0",



                    borderRadius:

                      "6px",



                    background:



                      pageNumber === 1



                        ? "#f8fafc"



                        : "#fff",



                    color:



                      pageNumber === 1



                        ? "#cbd5e1"



                        : "#475569",



                    fontSize:

                      "11px",



                    fontWeight:

                      500,



                    cursor:



                      pageNumber === 1



                        ? "not-allowed"



                        : "pointer",



                    transition:

                      "all 0.15s ease",



                  }}



                >





                  <span



                    style={{



                      fontSize:

                        "16px",



                      lineHeight:

                        1,



                    }}



                  >



                    ‹



                  </span>





                  Back





                </button>





                {/* PAGE NUMBERS */}



                <div
                  className="pagination-numbers"



                  style={{



                    display:

                      "flex",



                    alignItems:

                      "center",



                    gap:

                      "4px",



                  }}



                >





                  {



                    pageNumbers.map(



                      (page) => (



                        <button



                          key={

                            page

                          }



                          type="button"



                          onClick={() =>



                            setPageNumber(

                              page

                            )



                          }



                          style={{



                            height:

                              "32px",



                            minWidth:

                              "32px",



                            padding:

                              "0 9px",



                            display:

                              "inline-flex",



                            alignItems:

                              "center",



                            justifyContent:

                              "center",



                            border:



                              pageNumber ===

                              page



                                ? "1px solid #2563eb"



                                : "1px solid #e2e8f0",



                            borderRadius:

                              "6px",



                            background:



                              pageNumber ===

                              page



                                ? "#2563eb"



                                : "#fff",



                            color:



                              pageNumber ===

                              page



                                ? "#fff"



                                : "#475569",



                            fontSize:

                              "11px",



                            fontWeight:

                              600,



                            cursor:

                              "pointer",



                            transition:

                              "all 0.15s ease",



                          }}



                        >





                          {

                            page

                          }





                        </button>



                      )



                    )



                  }





                </div>





                {/* NEXT */}



                <button



                  type="button"



                  disabled={



                    pageNumber >=

                    totalPages



                  }



                  onClick={() =>



                    setPageNumber(



                      (previous) =>



                        Math.min(



                          totalPages,



                          previous + 1



                        )



                    )



                  }



                  style={{



                    height:

                      "32px",



                    minWidth:

                      "66px",



                    padding:

                      "0 10px",



                    display:

                      "inline-flex",



                    alignItems:

                      "center",



                    justifyContent:

                      "center",



                    gap:

                      "3px",



                    border:

                      "1px solid #e2e8f0",



                    borderRadius:

                      "6px",



                    background:



                      pageNumber >=

                      totalPages



                        ? "#f8fafc"



                        : "#fff",



                    color:



                      pageNumber >=

                      totalPages



                        ? "#cbd5e1"



                        : "#475569",



                    fontSize:

                      "11px",



                    fontWeight:

                      500,



                    cursor:



                      pageNumber >=

                      totalPages



                        ? "not-allowed"



                        : "pointer",



                    transition:

                      "all 0.15s ease",



                  }}



                >





                  Next





                  <span



                    style={{



                      fontSize:

                        "16px",



                      lineHeight:

                        1,



                    }}



                  >



                    ›



                  </span>





                </button>





              </div>





            </div>



          )

        }





      </div>





      {/* =====================================================

          ADD / EDIT POPUP

      ===================================================== */}



      {

        modalOpen &&

        (



          <div



            className="

              um-modal-backdrop

            "



            onMouseDown={() =>

              setModalOpen(

                false

              )

            }



          >





            <form



              className="

                um-modal

                um-modal-role

              "



              onSubmit={

                save

              }



              onMouseDown={(e) =>

                e.stopPropagation()

              }



            >





              <div className="um-modal-head">





                <h3>





                  {



                    editing



                      ? "Edit User Role"



                      : "Add New User Role"



                  }





                </h3>





                <button



                  type="button"



                  className="

                    um-close-btn

                  "



                  onClick={() =>

                    setModalOpen(

                      false

                    )

                  }



                >





                  <X

                    size={20}

                  />





                </button>





              </div>





              <div className="um-modal-body">





                <div className="um-grid-2">





                  <label className="um-field">





                    <span>

                      Role Name

                    </span>





                    <input



                      value={

                        form.name

                      }



                      onChange={(e) =>



                        setForm(



                          (prev) => ({



                            ...prev,



                            name:

                              e.target.value,



                          })



                        )



                      }



                      placeholder="

                        Role Name

                      "



                    />





                  </label>





                  <label className="um-field">





                    <span>

                      Description

                    </span>





                    <input



                      value={

                        form.description

                      }



                      onChange={(e) =>



                        setForm(



                          (prev) => ({



                            ...prev,



                            description:

                              e.target.value,



                          })



                        )



                      }



                      placeholder="

                        Description

                      "



                    />





                  </label>





                </div>





              </div>





              <div className="um-modal-foot">





                <button



                  type="button"



                  className="

                    um-cancel-btn

                  "



                  onClick={() =>

                    setModalOpen(

                      false

                    )

                  }



                >





                  Cancel





                </button>





                <button



                  className="

                    um-primary-btn

                  "



                  type="submit"



                >





                  {



                    editing



                      ? "Update"



                      : "Add"



                  }





                </button>





              </div>





            </form>





          </div>



        )

      }





      {/* =====================================================

          DELETE POPUP

      ===================================================== */}



      {

        deleteTarget &&

        (



          <div



            className="

              um-modal-backdrop

            "



            onMouseDown={() =>

              setDeleteTarget(

                null

              )

            }



          >





            <div



              className="

                um-modal

                um-modal-role

              "



              onMouseDown={(e) =>

                e.stopPropagation()

              }



            >





              <div className="um-modal-head">





                <h3>

                  Delete User Role

                </h3>





                <button



                  type="button"



                  className="

                    um-close-btn

                  "



                  onClick={() =>

                    setDeleteTarget(

                      null

                    )

                  }



                >





                  <X

                    size={20}

                  />





                </button>





              </div>





              <div className="um-modal-body">





                <p>





                  Are you sure you want to delete{" "}





                  <strong>



                    {

                      deleteTarget.name

                    }



                  </strong>





                  ?





                </p>





              </div>





              <div className="um-modal-foot">





                <button



                  type="button"



                  className="

                    um-cancel-btn

                  "



                  onClick={() =>

                    setDeleteTarget(

                      null

                    )

                  }



                >





                  Cancel





                </button>





                <button



                  type="button"



                  className="

                    um-primary-btn

                  "



                  onClick={

                    confirmDelete

                  }



                >





                  Delete





                </button>





              </div>





            </div>





          </div>



        )

      }





    </div>



  );



}